import { render, staticRenderFns } from "./GifSticker.vue?vue&type=template&id=285402b6"
import script from "./GifSticker.vue?vue&type=script&lang=js"
export * from "./GifSticker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('285402b6')) {
      api.createRecord('285402b6', component.options)
    } else {
      api.reload('285402b6', component.options)
    }
    module.hot.accept("./GifSticker.vue?vue&type=template&id=285402b6", function () {
      api.rerender('285402b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/GifSticker.vue"
export default component.exports